<section class="section">

    <div class="container-fluid">

        <div class="row align-items-center">

            <!-- From Date -->
            <div class="col-lg-2 col-md-3 mt-2">
                <div class="form-floating">
                    <input type="date"
                           [(ngModel)]="fromDate"
                           class="form-control"
                           (change)="onDate()"
                           [max]="toDate || todayMax">

                    <label>From Date</label>
                </div>
            </div>

            <!-- To Date -->
            <div class="col-lg-2 col-md-3 mt-2">
                <div class="form-floating">
                    <input type="date"
                           [(ngModel)]="toDate"
                           class="form-control"
                           (change)="onDate()"
                           [max]="todayMax">

                    <label>To Date</label>
                </div>
            </div>

            <!-- User Type -->
            <div class="col-lg-2 col-md-3 mt-2">
                <div class="form-floating">
                    <select class="form-select"
                            [(ngModel)]="selectedUserType"
                            (change)="applyFilters()">

                        <option value="">ALL</option>
                        <option value="USER">Customer</option>
                        <option value="ADMIN">Admin</option>
                        <option value="SUPER_ADMIN">Super Admin</option>

                    </select>

                    <label>User Type</label>
                </div>
            </div>

            <!-- Search -->
            <div class="col-lg-3 col-md-3 mt-2">
                <div class="form-floating">
                    <input type="text"
                           class="form-control"
                           placeholder="Search"
                           [(ngModel)]="searchText"
                           (input)="applyFilters()">

                    <label>Search</label>
                </div>
            </div>

        </div>

        <div class="py-2"></div>

        <div class="container-fluid">

            <div class="table-style table-responsive table-bordered">

                <table class="table table-head-fixed text-nowrap text-center">

                    <thead>

                        <tr class="sticky-top">
                            <th>S.No</th>
                            <th>Name</th>
                            <th>User Type</th>
                            <th>Action</th>
                            <th>Screen Name</th>
                            <th class="w-50">Description</th>
                            <th>Time</th>
                        </tr>

                    </thead>

                    <tbody *ngIf="currentFilterDetails.length > 0; else noDataFound">

                        <tr *ngFor="let item of currentFilterDetails; let i = index">

                            <td>{{ i + 1 }}</td>

                            <td>{{ item?.name || '-' }}</td>

                            <td>{{ item?.userType || '-' }}</td>

                            <td>{{ item?.action || '-' }}</td>

                            <td>{{ item?.screenName || '-' }}</td>

                            <td class="text-wrap w-50">
                                {{ item?.description || '-' }}
                            </td>

                            <td>
                                {{ item?.time | date:'dd/MM/yyyy hh:mm a' }}
                            </td>

                        </tr>

                    </tbody>

                    <ng-template #noDataFound>

                        <tr class="text-center ubuntu-bold h6 text-danger">
                            <td colspan="7">
                                Data Not Found
                            </td>
                        </tr>

                    </ng-template>

                </table>

            </div>

        </div>

    </div>

</section>